import { z } from 'zod/v4'
import { useMesaParameterStore } from '@/src/services/Statsig/useMesaParameterStore'

export const CardDisputeURLSchema = z.object({
  dispute_url: z.string(),
})

export type CardDisputeURL = z.infer<typeof CardDisputeURLSchema>

export function useCardDisputeURL() {
  return useMesaParameterStore('transaction_dispute_url')
}
